module.exports = __webpack_public_path__ + "static/27-02e95f544bfa8bf8b8db517871a60dea.jpg";